export const FETCH_CURRENCY = {
  START: 'CONFIG:FETCH_CURRENCY_START',
  SUCCESS: 'CONFIG:FETCH_CURRENCY_SUCCESS',
  ERROR: 'CONFIG:FETCH_CURRENCY_ERROR',
};

export const SET_SETTINGS = {
  START: 'CONFIG:SET_SETTINGS_START',
  SUCCESS: 'CONFIG:SET_SETTINGS_SUCCESS',
  ERROR: 'CONFIG:SET_SETTINGS_ERROR',
};

export const SAVE_SETTINGS = {
  START: 'CONFIG:SAVE_SETTINGS_START',
  SUCCESS: 'CONFIG:SAVE_SETTINGS_SUCCESS',
  ERROR: 'CONFIG:SAVE_SETTINGS_ERROR',
};

export const FETCH_SERVICE_ENDPOINTS = {
  START: 'FETCH_SERVICE_ENDPOINTS_START',
  SUCCESS: 'FETCH_SERVICE_ENDPOINTS_SUCCESS',
  ERROR: 'FETCH_SERVICE_ENDPOINTS_ERROR',
};
